import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private router = inject(Router);

  private routesToShowTabs = [
    '/',
    '/pages/dashboard',
    '/pages/profile',
    '/pages/profile/user-data',
    '/pages/profile/new-password',
    '/pages/earnings',
    '/pages/support',
    '/pages/admin',
    '/pages/admin/invoices',
  ];
  private adminRoutes = [
    '/pages/admin',
    '/pages/admin/invoices',
    '/pages/admin/payees-management',
    '/pages/admin/compositions-management',
  ];
  showTabs = true;
  hideSelectPayee = false;
  hideArtistName = false;

  constructor() {
    this.observeNavigationState();
  }

  observeNavigationState(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.hideArtistName = this.adminRoutes.some(route => event.url.startsWith(route));
        this.hideSelectPayee = this.adminRoutes.some(route => event.url.startsWith(route));
        this.showTabs = this.routesToShowTabs.includes(event.url);
      }
    });
  }

}